export const layoutStyles = {
  outerAppContainer: {
    flexGrow: 1,
    height: "calc(100vh - 64px)",
    overflow: "hidden",
    transition: "margin-left 0.3s ease",
  },
  innerAppContainer: {
    px: 3,
    pt: 2,
    flex: 1,
    overflowY: "auto",
    "&::-webkit-scrollbar": { display: "none" },
    msOverflowStyle: "none",
    scrollbarWidth: "none",
  },
  popover: {
    paperProps: {
      borderRadius: "8px",
      backgroundColor: "#ffffff",
      minWidth: "150px",
      zIndex: 1300,
      marginLeft: "30px",
    },
  },
  searchedItems: {
    "&:hover": {
      backgroundColor: "#f0f0f0",
      transition: "background-color 0.3s ease",
      borderRadius: 2,
    },
  },
  secondaryItemsContainer: {
    position: "absolute",
    bottom: "8px",
    left: "50%",
    transform: "translateX(-50%)",
    textAlign: "center",
    width: "100%",
    px: 2,
  },
  profileUpdateContainer: {
    position: "fixed",
    bottom: "20px",
    width: "500px",
    bgcolor: "white",
    boxShadow: 24,
    borderRadius: "8px",
    zIndex: 100,
    transition: "opacity 0.3s ease, transform 0.3s ease",
    maxHeight: "calc(80vh - 0)",
  },
  profileInnerContainer: {
    pt: 2,
    pb: 1.5,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "150px",
    "@media (max-height: 600px)": {
      pt: 1.5,
      pb: 1,
    },
  },
  profileAvatar: {
    backgroundColor: "#D04D00",
    width: 60,
    height: 60,
    fontSize: "2rem",
    mb: 1,
    transition: "transform 0.3s ease",
    "&:hover": { transform: "scale(1.1)" },
  },
  profileContentContainer: {
    px: 2.5,
    pt: 1.5,
    borderTop: "1px solid #D1D9EF",
    borderBottom: "1px solid #D1D9EF",
    maxHeight: "calc(70vh - 0px)",
    overflowY: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: "#CCD2DE transparent",
    "@media (max-height: 600px)": {
      maxHeight: "calc(60vh + 10px)",
    },
    "@media (max-height: 550px)": {
      maxHeight: "calc(50vh - 0px)",
    },
    "@media (max-height: 450px)": {
      maxHeight: "calc(40vh - 0px)",
    },
  },
  profileButtonCont: {
    px: 2.5,
    pb: 1.5,
    display: "flex",
    justifyContent: "flex-end",
    mt: 1.5,
    gap: 2,
    "@media (max-height: 600px)": {
      pb: 1,
    },
  },
  topbar: {
    indicatorContainer: {
      margin: 1,
      textAlign: "center",
    },
    indicator: {
      height: "5px",
      width: "100%",
      borderTopLeftRadius: "6px",
      borderTopRightRadius: "6px",
    },
  },
  border: {
    borderTop: "1px solid #757575",
    marginTop: 0,
    marginBottom: "0.3rem",
  },
};
